// extracted by mini-css-extract-plugin
export var card = "_ld-5";
export var cardSelected = "_ld-4";
export var image = "_ld-3";
export var modal = "_ld-0";
export var modalContent = "_ld-1";
export var table = "_ld-2";